import SynthesesShell from "./SynthesesShell";
import SynthesesProjetsBoard from "./SynthesesProjetsBoard";

function SynthesesProjets() {
  return (
    <SynthesesShell
      active="projets"
      title="Suivi de financements • Projets"
      description="Vue projets avec synthèse annuelle, mensuelle et détail des contrats."
    >
      <SynthesesProjetsBoard />
    </SynthesesShell>
  );
}

export default SynthesesProjets;
